import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import React from 'react';
import { Row, Col } from 'reactstrap';
import { IconNames } from '@blueprintjs/icons';
import {
  Icon,
  Intent,
  InputGroup,
  Hotkey,
  Hotkeys,
  HotkeysTarget,
} from '@blueprintjs/core';
import styled from 'styled-components';
import { createForm } from 'rc-form';
import moment from 'moment';
import { setMenuSelected } from '@redux/actions/menuAction';

import DateRangeInput from 'components/elements/date-range-input';
import SelectBoPhanBanHanh from 'components/elements/select-bo-phan-ban-hanh';
import SelectLoaiVanBan from 'components/elements/select-loai-van-ban';
import SelectLinhVuc from 'components/elements/select-linh-vuc';
import SelectTinhTrangVanBan from 'components/elements/select-tinh-trang-van-ban';
import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import { DATE_FORMAT } from 'config';
import { getList, exportData } from 'api/legalDocumentApi';
import slug from 'constants/slug';
import Clearfix from 'components/elements/clearfix';
import PageLockHOC from 'hoc/pageLock';
import { COLOR } from 'config';

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;
const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
  padding-right: 8px;
`;

@PageLockHOC(['legalDocument.view'])
@HotkeysTarget
class LegalDocumentList extends BaseListContainer {
  constructor(props) {
    const funcApi = {
      getList,
      exportData,
    };
    const columns = [
      {
        dataField: 'LegalDocumentNumber',
        text: 'Số văn bản',
        formatter: (cell, row) => {
          return (
            <Link
              target='_blank'
              to={`${slug.LEGAL_DOCUMENTS.VIEW_WITH_ID}${row._id ? row._id : ''
                }`}
            >
              <NameContainer>{cell}</NameContainer>
            </Link>
          );
        },
      },
      {
        dataField: 'promulgate.Name',
        text: 'Bộ phận ban hành',
        formatter: (cell, row) => {
          return <div>{cell}</div>
        }
      },
      {
        dataField: 'type.Name',
        text: 'Loại văn bản',
        formatter: (cell, row) => {
          return <div>{cell}</div>
        }
      },
      {
        dataField: 'Content',
        text: 'Nội dung văn bản',
        formatter: (cell, row) => {
          return <div>{cell}</div>
        }
      },
      {
        dataField: 'mainField.Name',
        text: 'Lĩnh vực',
        formatter: (cell, row) => {
          return <div>{cell}</div>
        }
      },
      {
        dataField: 'Signer',
        text: 'Người ký',
        formatter: (cell, row) => {
          return <div>{cell}</div>
        }
      },
      {
        dataField: 'IssueDate',
        text: 'Ngày ban hành',
        formatter: (cell, row) => {
          if (!cell) {
            return null;
          }
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
      {
        dataField: 'ExpiryDate',
        text: 'Ngày hết hạn',
        formatter: (cell, row) => {
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
      {
        dataField: 'status.Name',
        text: 'Tình trạng',
        formatter: (cell, row) => {
          return <div>{cell}</div>
        }
      },
    ];
    super(
      props,
      funcApi,
      columns,
      slug.LEGAL_DOCUMENTS.CREATE,
      'legalDocument'
    );
    this.state = {
      ...this.state,
    };
  }

  renderSearchContainer() {
    const { getFieldProps } = this.props.form;
    return (
      <div>
        <Row>
          <Col>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <LabelContainer>Tìm kiếm</LabelContainer>
              <div style={{ flex: 1 }}>
                <InputGroup
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                      this.submit();
                    }
                  }}
                  placeholder='Số văn bản/Nội dung văn bản'
                  {...getFieldProps('search', {})}
                />
              </div>
              <Clearfix width={8} />
              <Icon
                icon={IconNames.SEARCH}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.SUCCESS}
                style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                onClick={this.submit.bind(this)}
              />
            </div>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <SelectBoPhanBanHanh
              label='Bộ phận ban hành'
              fieldForm={{
                form: this.props.form,
                name: 'promulgate',
              }}
            />
          </Col>
          <Col xs={4}>
            <SelectLoaiVanBan
              label='Loại văn bản'
              fieldForm={{
                form: this.props.form,
                name: 'type',
              }}
            />
          </Col>
          <Col xs={4}>
            <SelectLinhVuc
              label='Lĩnh vực'
              fieldForm={{
                form: this.props.form,
                name: 'mainField',
              }}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <DateRangeInput
              label='Ngày ban hành'
              singleMonthOnly={true}
              shortcuts={false}
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              {...getFieldProps('IssueDate', {})}
            />
          </Col>

          <Col xs={4}>
            <SelectTinhTrangVanBan
              label='Tình trạng'
              fieldForm={{
                form: this.props.form,
                name: 'status',
              }}
            />
          </Col>
        </Row>
      </div>
    );
  }

  renderHotkeys() {
    return (
      <Hotkeys>
        <Hotkey
          //global={true}
          allowInInput={true}
          combo='enter'
          label='Be awesome all the time'
          onKeyDown={this.submit.bind(this)}
        />
      </Hotkeys>
    );
  }

  submit() {
    this.props.form.validateFields((error, values) => {
      if (error) return;
      // console.log(values, '--values-');
      if (values.promulgate) {
        values.promulgate = _.get(values, 'promulgate.value');
      }
      if (values.type) {
        values.type = _.get(values, 'type.value');
      }
      if (values.mainField) {
        values.mainField = _.get(values, 'mainField.value');
      }
      if (values.status && !values.status.value) {
        delete values.status;
      }
      console.log(values, '-----');
      super.handelSubmitSearch(values);
    });
  }
}

const mapStateToProps = (state) => ({
  menuStore: state.menu,
});

const mapDispatchToProps = {
  setMenuSelected,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(createForm()(LegalDocumentList))
);



// WEBPACK FOOTER //
// ./src/containers/LegalDocument/LegalDocumentList/index.js